import type { Transaction } from '@tiptap/pm/state'
import { ReplaceStep } from '@tiptap/pm/transform'

// Does this transaction replace the ENTIRE document in a single ReplaceStep?
// y-prosemirror expresses every Yjs-origin change this way (one ReplaceStep
// spanning 0..oldSize — a remote co-editor edit, a collab undo/redo, a sync
// tick), as does the host's `setContent`. Under that step's whole-doc StepMap
// every interior anchor collapses, so the AIProposals collapse guards drop each
// pending proposal — which is exactly the case relative-anchor reposition
// recovers. `tr.docs[i]` is the doc BEFORE step `i`, so the step's range is
// compared against that doc's size. Ordinary local edits (even large deletions)
// never span 0..size, so they never trigger reposition and keep using PM
// mapResult, which is authoritative for them.
export function isWholeDocReplace(transaction: Transaction): boolean {
  return transaction.steps.some((step, i) => {
    if (!(step instanceof ReplaceStep)) {
      return false
    }
    const docBefore = transaction.docs[i]
    return (
      docBefore !== undefined &&
      step.from === 0 &&
      step.to === docBefore.content.size
    )
  })
}
